import { Component, OnInit } from "@angular/core";
import { UserManagementService } from "../../core/services/user-management.service";
import { UserProfileService } from "../../core/services/user-profile.service";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { PanelModule } from "primeng/panel";
import { GenericResponseDto } from "../../core/models/generic-response.dto";
import { ValidateLogin } from "../../core/models/validate-login.dto";
import { SharedService } from "../../core/services/shared.service";
import { UserRole } from "../../shared/enums/userRoles.enum";

@Component({
  selector: "jni-reports",
  templateUrl: "./reports.component.html",
  styleUrls: ["./reports.component.scss"],
  standalone: true,
  imports: [CommonModule, RouterModule, PanelModule],
})
export class ReportsComponent implements OnInit {
  userRole = 0;
  saleOrderListAdminStatus = false;
  loggedInUserIsAdmin = false;
  loggedInUserIsBC = false;

  constructor(
    private _userManagementService: UserManagementService,
    private _sharedService: SharedService,
    private _profileFormService: UserProfileService
  ) {}

  ngOnInit() {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    delete (window?.opener as any)?.sourcePage;
    /* eslint-enable @typescript-eslint/no-explicit-any */
    this.getUserProfile();
    this.getUserRole();
    this.clearAndSetSimpleOrderSearchResponseObj();
    this._sharedService.setOrderSearchValue("");
    this._sharedService.setOrderSearchPlaceholderValue("Search");
  }

  getUserProfile() {
    this._userManagementService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.userRole = res.data.userRoleId;
        if (this.userRole === UserRole.Admin) {
          this.loggedInUserIsAdmin = true;
        } else {
          this.getUserById(res?.data?.userId);
        }
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: res => {
        if (res?.data) {
          if (
            res?.data?.title?.toLowerCase()?.includes("branding consultant")
          ) {
            this.loggedInUserIsBC = true;
          }
        }
      },
    });
  }

  getUserRole() {
    this._userManagementService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.userRole = res.data.userRoleId;
        if (this.userRole === UserRole.Admin) {
          this.saleOrderListAdminStatus = true;
        }
      });
  }

  clearAndSetSimpleOrderSearchResponseObj() {
    const orderSearch: string[] = [];
    this._sharedService.setSimpleOrderSearchResponseObject(orderSearch);
  }
}
